export interface NewsItem {
  id: string;
  title: string;
  category: '电影新闻' | '影评' | '访谈';
  date: string;
  summary: string;
  cover: string;
  content: string[];
}

export const newsList: NewsItem[] = [
  {
    id: 'news-1',
    title: '《泰坦尼克号》4K修复版即将重映，画面质感全面升级',
    category: '电影新闻',
    date: '2026-09-28',
    summary: '经典电影《泰坦尼克号》将以4K修复版本重返大银幕，修复团队耗时两年完成画面与音效的全面升级。',
    cover: 'https://readdy.ai/api/search-image?query=Cinema%20theater%20screen%20showing%20vintage%20ocean%20liner%20scene%2C%20deep%20navy%20blue%20ambient%20lighting%2C%20golden%20accent%20glow%2C%20movie%20premiere%20atmosphere%2C%20editorial%20photography%20style&width=1200&height=720&seq=news-cover-01&orientation=landscape',
    content: [
      '经典爱情灾难片《泰坦尼克号》将以全新4K修复版本重返全球院线，这是该片自1997年上映以来规模最大的一次画面修复工程。',
      '修复团队耗时两年，对原始胶片逐帧进行数字化处理，修复了大量划痕、噪点与色彩偏差问题，同时对环绕声音效进行了重新混音。',
      '制片方表示，此次重映将让新老观众都能以更震撼的视听效果重新体验这段跨越阶级的浪漫传奇。',
    ],
  },
  {
    id: 'news-2',
    title: '影评：为什么《泰坦尼克号》历经近三十年仍能打动观众',
    category: '影评',
    date: '2026-09-15',
    summary: '从叙事结构到情感共鸣，深入解析《泰坦尼克号》长盛不衰的艺术魅力与时代意义。',
    cover: 'https://readdy.ai/api/search-image?query=Romantic%20couple%20silhouette%20standing%20at%20ship%20bow%20against%20golden%20sunset%20sky%20deep%20navy%20ocean%2C%20cinematic%20film%20still%20style%2C%20warm%20dramatic%20lighting&width=1200&height=720&seq=news-cover-02&orientation=landscape',
    content: [
      '《泰坦尼克号》之所以经久不衰，核心在于它将宏大的历史灾难与细腻的个人情感完美融合。',
      '杰克与露丝的爱情故事超越了阶级与时代的限制，成为观众心中永恒的浪漫符号。',
      '影片在特效制作、配乐运用和叙事节奏上的成就，至今仍被视为好莱坞工业的标杆之作。',
    ],
  },
  {
    id: 'news-3',
    title: '专访历史顾问：还原泰坦尼克号真实历史细节的幕后故事',
    category: '访谈',
    date: '2026-08-30',
    summary: '我们采访了多部泰坦尼克号题材作品的历史顾问，了解影视创作中如何平衡艺术加工与历史真实。',
    cover: 'https://readdy.ai/api/search-image?query=Historian%20reviewing%20old%20blueprints%20of%20ocean%20liner%20in%20study%20room%2C%20deep%20navy%20blue%20tones%2C%20warm%20golden%20desk%20lamp%20light%2C%20documentary%20interview%20photography%20style&width=1200&height=720&seq=news-cover-03&orientation=landscape',
    content: [
      '作为多部泰坦尼克号相关影视作品的历史顾问，我们的嘉宾分享了幕后考证工作的艰辛与乐趣。',
      '从船体结构到乘客服饰，每一个细节都需要查阅大量历史档案，力求在艺术创作与史实之间找到平衡。',
      '他认为，正是这种对细节的极致追求，才让泰坦尼克号题材的作品能够持续打动不同时代的观众。',
    ],
  },
  {
    id: 'news-4',
    title: '泰坦尼克号沉船遗址最新深海探测成果公布',
    category: '电影新闻',
    date: '2026-08-10',
    summary: '科研团队公布最新深海探测数据，为后续纪录片与影视创作提供了珍贵的第一手资料。',
    cover: 'https://readdy.ai/api/search-image?query=Deep%20sea%20submarine%20exploring%20shipwreck%20ruins%20with%20bright%20spotlight%2C%20deep%20navy%20blue%20underwater%20scene%2C%20golden%20light%20beams%2C%20documentary%20cinematic%20style&width=1200&height=720&seq=news-cover-04&orientation=landscape',
    content: [
      '一支国际科研团队近日公布了针对泰坦尼克号沉船遗址的最新深海探测成果。',
      '通过高清声呐与水下机器人技术，团队获取了残骸内部前所未有的清晰影像。',
      '这些珍贵资料将为未来的纪录片制作与历史研究提供重要支撑。',
    ],
  },
  {
    id: 'news-5',
    title: '影评人盘点：泰坦尼克号题材影视作品的五大经典瞬间',
    category: '影评',
    date: '2026-07-22',
    summary: '资深影评人从多部泰坦尼克号题材作品中精选出最具代表性的经典场景进行解读。',
    cover: 'https://readdy.ai/api/search-image?query=Grand%20ballroom%20dance%20scene%20on%20vintage%20ocean%20liner%2C%20elegant%20period%20costumes%2C%20deep%20navy%20blue%20and%20gold%20color%20palette%2C%20cinematic%20film%20still&width=1200&height=720&seq=news-cover-05&orientation=landscape',
    content: [
      '从船头展翅的经典画面到沉船时刻的悲壮场面，泰坦尼克号题材作品留下了许多难以磨灭的影像记忆。',
      '影评人认为，这些经典瞬间之所以深入人心，是因为它们精准捕捉了人性在灾难面前的光辉与脆弱。',
      '本文盘点了五大经典场景，带领读者重温这段跨越时代的影视传奇。',
    ],
  },
  {
    id: 'news-6',
    title: '独家专访：饰演幸存者后代的青年演员谈拍摄心路历程',
    category: '访谈',
    date: '2026-07-05',
    summary: '新生代演员分享了出演泰坦尼克号题材剧集的筹备过程与情感投入。',
    cover: 'https://readdy.ai/api/search-image?query=Young%20actor%20in%20period%20costume%20backstage%20preparing%20for%20film%20scene%2C%20deep%20navy%20blue%20ambient%20lighting%2C%20warm%20golden%20accent%2C%20behind%20the%20scenes%20photography%20style&width=1200&height=720&seq=news-cover-06&orientation=landscape',
    content: [
      '在最新一部泰坦尼克号题材剧集中，这位青年演员出演了一位幸存者后代角色。',
      '她表示，为了更好地理解角色，自己查阅了大量历史资料并走访了相关纪念馆。',
      '她希望通过自己的表演，让更多年轻观众重新认识这段历史。',
    ],
  },
];